import React, { useEffect, useState } from 'react';

import {
  Button,
  Input,
  Loading,
  ModalDefault,
  Page,
  PageHeader,
} from '~/components';
import BiblicalSchool from '~/services/BiblicalSchool';

import {
  ConfigActions,
  ConfigCard,
  ConfigField,
  ConfigTitle,
  Content,
  Select,
} from './styles';

const QuarterSettings: React.FC = () => {
  const [loading, setLoading] = useState(false);
  const [period, setPeriod] = useState({ year: '', quarter: '1' });
  const [isVisibleModalErro, setIsVisibleModalErro] = useState(false);
  const [isVisibleModalSuccess, setIsVisibleModalSuccess] = useState(false);

  useEffect(() => {
    const loadCurrentPeriod = async () => {
      setLoading(true);
      try {
        const currentPeriod = await BiblicalSchool.GetUpdateClassesPeriod();
        setPeriod({
          year: String(currentPeriod.year),
          quarter: String(currentPeriod.quarter),
        });
      } catch (e) {
        console.log(e);
        setIsVisibleModalErro(true);
      } finally {
        setLoading(false);
      }
    };

    loadCurrentPeriod();
  }, []);

  const savePeriod = async () => {
    const year = Number(period.year);
    const quarter = Number(period.quarter);

    if (!year || quarter < 1 || quarter > 4) {
      setIsVisibleModalErro(true);
      return;
    }

    setLoading(true);

    try {
      const updatedPeriod = await BiblicalSchool.UpdateUpdateClassesPeriod({
        year,
        quarter,
      });

      setPeriod({
        year: String(updatedPeriod.year),
        quarter: String(updatedPeriod.quarter),
      });
      setIsVisibleModalSuccess(true);
    } catch (e) {
      console.log(e);
      setIsVisibleModalErro(true);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <Page>
        <Loading />
      </Page>
    );
  }

  return (
    <>
      {isVisibleModalErro && (
        <ModalDefault
          success={false}
          onClick={() => setIsVisibleModalErro(false)}
        >
          Ops algo deu errado
        </ModalDefault>
      )}
      {isVisibleModalSuccess && (
        <ModalDefault success onClick={() => setIsVisibleModalSuccess(false)}>
          Período da EBD atualizado com sucesso.
        </ModalDefault>
      )}

      <Page>
        <PageHeader title="Configuração de Trimestre" />

        <Content>
          <ConfigCard>
            <ConfigTitle>Período Atual da EBD</ConfigTitle>
            <ConfigField>
              <Input
                label="Ano"
                type="number"
                value={period.year}
                onChange={e =>
                  setPeriod({
                    ...period,
                    year: e.currentTarget.value,
                  })
                }
              />
            </ConfigField>
            <ConfigField>
              <span>
                <b>Trimestre</b>
              </span>
              <Select
                id="quarter-select"
                aria-label="Trimestre"
                value={period.quarter}
                onChange={e =>
                  setPeriod({
                    ...period,
                    quarter: e.target.value,
                  })
                }
              >
                <option value="1">1º trimestre</option>
                <option value="2">2º trimestre</option>
                <option value="3">3º trimestre</option>
                <option value="4">4º trimestre</option>
              </Select>
            </ConfigField>
            <ConfigActions>
              <Button onClick={savePeriod}>Salvar período</Button>
            </ConfigActions>
          </ConfigCard>
        </Content>
      </Page>
    </>
  );
};

export default QuarterSettings;
